import { render, staticRenderFns } from "./P0703.vue?vue&type=template&id=5bc401d4&"
import script from "./P0703.vue?vue&type=script&lang=ts&"
export * from "./P0703.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports